import * as types from './types';

const INITIAL_STATE = {
  report: null,
  excelReport: null,
  reportLoading: false,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.EXTENDED_BENEFITS_REPORT_FETCHING:
      return { ...state, loading: payload, reportLoading: payload };

    case types.EXTENDED_BENEFITS_GET_REPORT:
      return { ...state, report: payload };

    case types.EXTENDED_BENEFITS_CLEAR_REPORT:
      return { ...state, report: null, excelReport: null, error: null };

    case types.EXTENDED_BENEFITS_FETCH_ERROR:
      return { ...state, error: payload };

    case types.EXTENDED_BENEFITS_GET_EXCEL_REPORT:
      return {
        ...state,
        excelReport: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/extendedbenefits/state/report/reducer.js